import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.EpiBuilder,
  title: 'ePI Builder',
  category: ComponentCategory.ePI,
};
